export default "__VITE_ASSET__DktXRsPy__"